import React, { useEffect, useState} from 'react';
import {useAppSelector} from "../DAL/store";
import Error from "../ui/error";
import Table from "../ui/table";



/**
 * the entry point
 */
const CompareServersApp = () => {

    const pcWrap = useAppSelector(store => store.pcWrap);
    const isError = !pcWrap || !pcWrap.productCompareUnionList || pcWrap.productCompareUnionList.length <= 0;

    return (
        <>
            <div className="hidden md:block">
                {
                    isError &&
                    <Error />
                }

                {
                    !isError &&
                    <div>
                        {/*<div>pcWrap1: {pcWrap?.productCompareUnionList.length}</div>*/}
                        <Table />
                    </div>
                }
            </div>

            <div className="md:hidden info-box">
                Compare bundles is available on ipad and desktop.
            </div>
        </>
    )
};

export default CompareServersApp;